export default {
    ENVIRONMENT: "production",
    ENVIRONMENTS: {
        production: {
            API_URL: "https://api.swiftsales.io",
            BASE_IMG_PATH: "https://s3.us-east-2.amazonaws.com/swiftchat.io/"
        },
        development: {
            API_URL: "https://api.swiftsales.io",
            BASE_IMG_PATH: "https://s3.us-east-2.amazonaws.com/swiftchat.io/"
        },
        staging: {
            API_URL: "https://api.swiftsales.io",
            BASE_IMG_PATH: "https://s3.us-east-2.amazonaws.com/swiftchat.io/"
        }
    },
};